import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { LocalStorageService } from '@services/local-storage.service';
import { SequencePreviewMode } from '@shared/models/enums/sequence-preview-mode.enum';
import { TuiIcon } from '@taiga-ui/core';
import { TuiSegmented } from '@taiga-ui/kit';
import { SequencePreviewModeService } from '../services/sequence-preview-mode.service';

@Component({
  selector: 'pxc-sequence-preview-mode-segmented',
  imports: [TuiSegmented, TuiIcon, TranslocoDirective],
  templateUrl: './sequence-preview-mode-segmented.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SequencePreviewModeSegmentedComponent {
  @Input() previewMode: SequencePreviewMode;
  @Output() previewModeChanged = new EventEmitter<SequencePreviewMode>();

  SequencePreviewMode = SequencePreviewMode;

  readonly localStorageService = inject(LocalStorageService);
  readonly sequencePreviewModeService = inject(SequencePreviewModeService);

  onModeChange(mode: SequencePreviewMode): void {
    this.sequencePreviewModeService.setPreviewMode(mode);
    this.previewModeChanged.emit(mode);
  }
}
